var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyleavesIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 226,
    viewBox: "0 0 250 226",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2029 35.7124C20.8147 57.7477 17.7521 79.5064 15.6961 101.897C14.0648 119.664 14.8457 140.001 8.60638 157.084C6.73309 162.214 3.85577 166.926 2 172.029",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4785 38.6125C25.9309 44.6454 29.9433 48.2836 34.0658 52.7115C40.7249 59.8639 46.9543 66.907 51.186 75.7936C53.7478 81.1734 54.3647 87.1006 54.7712 92.9943C55.3584 101.509 56.7227 110.014 57.027 118.534C57.835 141.157 51.3069 163.366 51.3069 185.886C51.3069 194.382 53.0435 201.605 57.1479 209.13C57.2932 209.396 62.9083 219.298 62.9083 216.26",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3027 34.2621C54.5845 28.4724 86.7537 21.9918 119.022 16.0946C130.505 13.9958 142.399 10.9504 154.108 10.3341C157.784 10.1406 157.299 27.5711 158.257 31.402C161.143 42.947 160.609 56.4042 159.345 68.0996C158.638 74.6353 157.17 81.4217 157.17 87.9188C157.17 92.0356 157.888 95.5143 159.345 99.3994C160.623 102.808 163.283 105.794 164.34 109.228C166.801 117.226 167.862 125.578 171.671 133.197C173.123 136.1 175.297 140.873 175.297 144.073C175.297 146.237 176.458 148.977 176.868 151.163C177.985 157.123 180.537 164.748 184.32 169.612C185.835 171.56 187.853 174.198 188.308 176.702C188.888 179.891 179.93 181.417 178.237 181.939C165.724 185.801 152.932 188.642 140.331 192.171C127.659 195.719 114.886 199.893 103.795 207.116C95.8304 212.302 87.323 217.199 79.4237 222.06C77.5383 223.221 74.5077 224.656 72.2534 224.155C69.095 223.453 66.4576 219.405 63.6329 217.71",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 174.204C10.048 169.209 19.4731 166.688 28.8686 165.624C32.3969 165.225 35.2889 165.493 38.6976 164.456C43.3023 163.055 48.0631 161.769 52.7563 160.428",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1013 32.1116C28.1013 29.8562 26.4636 28.2879 29.0833 26.978C31.4752 25.7821 33.6726 28.4796 36.5771 29.0077C38.7961 29.4111 38.2537 35.9837 38.2537 37.8875",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M41.07 29.3699C41.07 27.1145 39.4323 25.5462 42.0521 24.2363C44.444 23.0404 46.6414 25.7379 49.5458 26.266C51.7649 26.6694 51.2224 33.242 51.2224 35.1458",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0388 26.6282C54.0388 24.3728 52.4011 22.8045 55.0208 21.4946C57.4127 20.2987 59.6101 22.9962 62.5146 23.5243C64.7336 23.9277 64.1912 30.5003 64.1912 32.4041",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0075 23.8865C67.0075 21.6311 65.3698 20.0628 67.9896 18.7529C70.3815 17.557 72.5789 20.2545 75.4833 20.7826C77.7024 21.186 77.1599 27.7586 77.1599 29.6624",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9763 21.1448C79.9763 18.8894 78.3386 17.3211 80.9583 16.0112C83.3502 14.8153 85.5476 17.5128 88.4521 18.0409C90.6711 18.4443 90.1287 25.0169 90.1287 26.9207",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M92.945 18.4031C92.945 16.1477 91.3073 14.5794 93.9271 13.2695C96.319 12.0736 98.5164 14.7711 101.421 15.2992C103.64 15.7026 103.097 22.2752 103.097 24.1791",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M105.914 15.6614C105.914 13.406 104.276 11.8377 106.896 10.5278C109.288 9.33191 111.485 12.0294 114.39 12.5575C116.609 12.9609 116.066 19.5335 116.066 21.4374",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M118.883 12.9197C118.883 10.6643 117.245 9.09604 119.865 7.78614C122.256 6.59021 124.454 9.28768 127.358 9.81577C129.577 10.2192 129.035 16.7918 129.035 18.6957",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M131.851 10.178C131.851 7.92264 130.214 6.35434 132.833 5.04445C135.225 3.84851 137.423 6.54598 140.327 7.07407C142.546 7.47753 142.004 14.0501 142.004 15.954",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M144.822 7.43633C144.822 5.18094 143.184 3.61264 145.804 2.30275C148.196 1.10681 150.393 3.80428 153.298 4.33237C155.517 4.73583 154.974 11.3084 154.974 13.2123",
    stroke: "#FB7C51",
    strokeWidth: 2.17468,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3301 56.0894C53.1997 58.4138 55.6905 60.2854 57.0398 62.9839C57.5915 64.0873 58.1584 65.295 58.8217 66.3333C59.6063 67.5613 60.1186 68.9643 60.9396 70.1584C61.7988 71.4083 62.1997 72.9553 62.7495 74.3847C63.0871 75.2624 63.4682 76.1494 63.7571 77.0436C64.0203 77.8582 64.6134 78.5693 64.8393 79.376C65.0271 80.0468 65.0335 80.5293 65.3431 81.1766C65.6193 81.7541 65.7616 82.3723 65.7723 83.0146C65.7859 83.8316 66.0062 84.4613 66.2014 85.2537C66.5042 86.4826 66.4095 87.879 66.6119 89.1441C66.7895 90.254 66.9478 91.2811 66.9478 92.4095C66.9478 93.009 68.8274 92.7019 69.1683 92.6987C74.6653 92.6466 80.227 92.2522 85.551 90.8141C88.4837 90.0219 91.2855 88.9084 94.2648 88.2578C97.4119 87.5706 100.597 87.1106 103.744 86.4199C104.63 86.2254 105.499 85.9319 106.393 85.8041C107.084 85.7054 105.515 81.2381 105.348 80.6822C104.565 78.0628 104.29 75.2713 103.277 72.7054C102.061 69.6242 101.32 66.1287 99.5267 63.3105C97.7646 60.5414 96.5497 57.5117 94.8153 54.7366C94.4178 54.1006 93.9494 52.6635 93.3226 52.2456C92.983 52.0192 92.948 51.4663 92.4736 51.3873C92.2434 51.3489 91.8367 50.7669 91.5406 50.6129C90.9842 50.3236 90.5897 49.3721 89.9546 49.3721",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M50.1543 55.5857C59.1099 54.9329 67.6604 52.9802 76.3891 50.9769C80.0981 50.1257 83.8642 49.6471 87.5846 48.8684C88.7836 48.6175 90.2306 47.8608 91.4657 47.8608",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6387 123.608C83.0252 122.733 89.6281 121.743 96.0804 121.743",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M106.201 119.879C120.744 118.17 135.227 116.227 149.612 113.487",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116 157C128.06 155.395 140.071 153.572 152 151",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M77.4347 145.339C87.4476 144.09 97.0301 140.472 106.83 138.196C110.507 137.343 114.398 136.248 118.192 136",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M77.1953 168.436C84.2828 167.825 91.1707 164.822 98.153 163.173C100.773 162.554 103.553 161.708 106.229 161.701",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M134.035 134.349C138.201 134.013 142.321 133.273 146.491 133",
    stroke: "#E9A28A",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M181.99 46.555C184.942 46.0602 189.165 44.6943 192.259 45.0607C193.517 45.2096 190.361 50.9426 190.261 51.1565C186.866 58.4217 183.562 65.8027 179.534 72.7436C179.369 73.0281 178.578 73.8811 179.298 73.9569C182.084 74.2502 185.121 73.8324 187.894 73.7054C193.914 73.4297 199.933 73.1875 205.96 73.1875",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M204 32.6102C205.756 32.4838 223.233 31.7551 223.233 32.0849C223.233 33.4335 221.379 35.2014 220.637 36.159C218.788 38.5461 217.2 41.0478 215.646 43.6301C215.245 44.2964 212.287 49 214.454 49C218.939 49 223.529 48.1413 228 47.7392",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M238.285 22.6987C239.53 22.3677 240.761 22.2151 242.014 22.2151C242.583 22.2151 243.736 21.6659 244.26 22.3226C244.996 23.2443 239.979 29.3752 239.812 29.5216C239.125 30.1256 238.359 30.3737 237.701 31.1602C237.487 31.4164 236.814 31.783 237.049 31.8855C240.894 33.5573 245.107 32.8525 249 32.8525",
    stroke: "#FB7C51",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.053 49.4209C101.682 51.3969 102.637 53.2356 103.338 55.1861C104.052 57.1736 104.729 59.2671 105.198 61.3276",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M101.064 49.2946C103.996 51.6317 107.128 53.6977 110.048 56.0578C110.171 56.1571 110.515 56.4277 110.665 56.5732C110.715 56.6218 110.767 56.782 110.808 56.7259C111.357 55.9856 111.292 54.3464 111.475 53.485C111.752 52.1833 112.024 50.8941 112.293 49.5916C112.534 48.4229 113.315 47.6135 113.726 46.4962C113.935 45.926 114.099 45.3536 114.147 44.7484C114.206 44.0017 114.025 46.2551 114.139 46.9954C114.342 48.3203 114.869 49.5544 115.154 50.8575C115.298 51.5164 115.224 52.1819 115.357 52.8457C115.639 54.2617 115.755 55.6987 116.037 57.0983C116.114 57.478 116.196 57.6835 116.276 58.0078",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M118.398 44.0535C118.169 47.348 117.965 51.3875 119.901 54.245C120.406 54.9895 121.367 55.8668 122.318 55.9423C124.243 56.095 127.31 56.3108 128.291 54.2531C129.216 52.3133 130.279 49.3463 128.36 47.5931C127.306 46.6303 126.505 45.7529 125.17 45.1277C124.256 44.6999 123.365 44.7409 122.373 44.5596C121.434 44.3879 120.477 44.3455 119.526 44.2702",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M130.096 42.564C131.399 43.142 131.878 43.6434 132.014 45.0204C132.097 45.8534 132.426 46.6289 132.556 47.4525C132.638 47.9641 132.588 48.5202 132.765 49.01C133.124 50.001 132.977 51.1465 132.896 52.1728C132.877 52.4098 132.915 53.402 133.107 52.7267",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M130 42.1748C133.519 43.13 136.984 44.2689 140.502 45.2272C142.199 45.6895 143.726 46.4723 145.349 47.1243C146.683 47.6604 147.958 48.0211 149.363 48.2909",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M143.648 36.8958C144.699 38.1761 145.612 39.465 146.118 41.0499C146.491 42.2173 146.732 43.2929 147.324 44.3828C148.193 45.9834 149.085 47.6753 150.458 48.8866",
    stroke: "#E9A28A",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyleavesIcon);
export default __webpack_public_path__ + "static/media/emptyleavesIcon.47c5ea3d85d7257bf3ebc504a7157d32.svg";
export { ForwardRef as ReactComponent };